import { lazyLoad } from '../../../shared/utils/loadable';

export const AboutPage = lazyLoad(
  () => import('./index'),
  (module) => module.About,
);
